import { render, staticRenderFns } from "./PluginIntroRowSlide.vue?vue&type=template&id=8b276ab6&scoped=true"
import script from "./PluginIntroRowSlide.vue?vue&type=script&lang=js"
export * from "./PluginIntroRowSlide.vue?vue&type=script&lang=js"
import style0 from "./PluginIntroRowSlide.vue?vue&type=style&index=0&id=8b276ab6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b276ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b276ab6')) {
      api.createRecord('8b276ab6', component.options)
    } else {
      api.reload('8b276ab6', component.options)
    }
    module.hot.accept("./PluginIntroRowSlide.vue?vue&type=template&id=8b276ab6&scoped=true", function () {
      api.rerender('8b276ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginIntroRowSlide.vue"
export default component.exports